import "../../components/button/StyledButton.css"
import AddEcomForm from "components/addEcomForm/AddEcomForm";
import { useGetEcomLatestQuery } from "api/api";
import * as z from "zod";
import { createEcomFieldValidation } from "./helpers";

const AddEcomTimberPage = () => {
  const { data: latestEcomData = [] } = useGetEcomLatestQuery();
  const filteredEcomData = latestEcomData['ECOMData'].filter(data => data.material_category === 'Timber');
  const materialMapping = filteredEcomData.reduce((accumulator, material) => {
    accumulator[material.material_type] = material.a1_a3_carbon_factor;
    return accumulator;
  }, {});

  const inputLabels = [
    { name: "softwood_lumber", label: "Softwood Lumber", value: null, type: 'number', latestValue: materialMapping['Softwood Lumber'], unit: "kgCO2e/CF", component: "FormTextField" },
    { name: "softwood_plywood", label: "Softwood Plywood", value: null, type: 'number', latestValue: materialMapping['Softwood Plywood'], unit: "kgCO2e/CF", component: "FormTextField" },
    { name: "glued_laminated_timber", label: "Glued Laminated Timber (Glulam)", value: null, type: 'number', latestValue: materialMapping['Glue Laminated Timber'], unit: "kgCO2e/CF", component: "FormTextField" },
    { name: "cross_laminated_timber", label: "Cross Laminated Timber (CLT)", value: null, type: 'number', latestValue: materialMapping['Cross Laminated Timber'], unit: "kgCO2e/CF", component: "FormTextField" },
    { name: "laminated_veneer_lumber", label: "Laminated Veneer Lumber (LVL)", value: null, type: 'number', latestValue: materialMapping['Laminated Veneer Lumber'], unit: "kgCO2e/CF", component: "FormTextField" },
    { name: "wood_i_joists", label: "Wood I-Joists", value: null, type: 'number', latestValue: materialMapping['Wood I Joists'], unit: "kgCO2e/lb", component: "FormTextField" },
  ];

  const inputNames = inputLabels.map((input) => input.name)

  const schema = z.object(
    Object.fromEntries(
      inputNames.map(key => [key, createEcomFieldValidation(key)])
    )
  );


  return (
    <AddEcomForm
      title="Timber"
      inputLabels={inputLabels}
      stage={6}
      validationSchema={schema}
    />
  );
}

export default AddEcomTimberPage;